'use client'
import { Intro } from '@/components/parts/intro/Intro'
import { SecurityProtect } from '../../parts/security/SecurityProtect'
import { Security } from '../../parts/Security'
import { Contact } from '@/components/parts/contact'

const SecurityContent = () => {
  return (
    <>
      <Intro title="セキュリティ" lead="大切な情報を守るLAWGUEの取り組み" />
      <SecurityProtect />
      <Security />
      <Contact bg="bg-lawguebase" />
    </>
  )
}

export default SecurityContent
